import React from 'react';
import classnames from 'classnames';
import {
  STATUS_APPLICATION_SUPPLY,
  STATUS_APPLICATION_WAGON,
} from 'helpers/constants';
import styles from './status.module.scss';

const getStatusValue = value => (
  value === null || value === undefined || value === '' ? null : Number(value)
);

const getStatusLabel = (value, status) => {
  if (value === null) {
    return 'Статус не указан';
  }

  return status.toString(value) || `Неизвестный статус (код: ${value})`;
};

const Status = ({ value, status }) => {
  const statusValue = getStatusValue(value);

  return (
    <div
      className={classnames(styles.status, {
        [styles.queue]: [
          STATUS_APPLICATION_SUPPLY.QUEUE,
          STATUS_APPLICATION_SUPPLY.CANCEL,
          STATUS_APPLICATION_WAGON.WORK,
        ].includes(statusValue),
        [styles.check]: [
          STATUS_APPLICATION_SUPPLY.CHECK,
          STATUS_APPLICATION_SUPPLY.WAIT,
        ].includes(statusValue),
        [styles.complete]: [
          STATUS_APPLICATION_SUPPLY.COMPLETE,
          STATUS_APPLICATION_SUPPLY.SHIPPED,
          STATUS_APPLICATION_SUPPLY.DELIVERED,
          STATUS_APPLICATION_WAGON.COMPLETE,
          STATUS_APPLICATION_WAGON.AGREED,
        ].includes(statusValue),
      })}
    >
      {getStatusLabel(statusValue, status)}
    </div>
  );
};

export default Status;
